const track = (data = [], { shouldPush = true }) => {
  if (typeof window === 'undefined' || !window.EA_push || !process.env.EULERIAN_URL) {
    return Promise.resolve();
  }

  const dataFormatted = Object.keys(data).reduce((acc, key) => [...acc, `${key}`, data[key]], []);

  return new Promise(resolve => {
    if (shouldPush) {
      window.EA_push([...window.EA_context, ...dataFormatted]);
    }
    setTimeout(resolve, 250);
  });
};

export default { track };
